/* LA MARIE · Entradas por evento en /collections/recordatorios (experimento A/B "evento") · Ola 2 · 22-oct-2026
   - La fila la pinta sections/lm-collection.liquid ([data-lm-evento], oculta por CSS = versión A). Solo hay botón para
     las etiquetas evento-* que tienen 3 diseños o más. No usa lm-chips.js ni sus clases (ese es el experimento "chips").
   - Versión B: clase lm-ab-evento-b en <html> (motor assets/lm-ab.js) o window.LMAB.v('evento') === 'B'. Sin clase = A.
   - Filtra en la misma página, sin recargar y SIN reordenar: solo pone [hidden] a las tarjetas sin ese evento
     (data-ev de cada .ccard). Tocar otra vez el botón activo vuelve a "Todos".
   - Eventos por window.lmTrack (si existe), sin datos personales:
       lm_chip_evento {evento, resultados, lm_ab_evento} en cada toque de botón (solo B, que es donde se ven);
       lm_rec_col_card {pos, handle, evento, lm_ab_evento} al tocar una tarjeta, en A y en B
       (evento = filtro activo o "todos"; pos = posición entre las tarjetas visibles, desde 1). */
(function () {
  'use strict';
  var html = document.documentElement;
  function variante() {
    try {
      if (html.classList.contains('lm-ab-evento-b')) return 'B';
      if (html.classList.contains('lm-ab-evento-a')) return 'A';
      if (window.LMAB && typeof window.LMAB.v === 'function') return String(window.LMAB.v('evento')).toUpperCase() === 'B' ? 'B' : 'A';
    } catch (e) {}
    return '';
  }
  function track(n, p) { try { if (typeof window.lmTrack === 'function') window.lmTrack(n, p); } catch (e) {} }

  function iniciar() {
    var grid = document.querySelector('.lmc .cgrid');
    if (!grid || grid.getAttribute('data-lmev-on')) return;
    grid.setAttribute('data-lmev-on', '1');
    var cards = [].slice.call(grid.querySelectorAll('.ccard'));
    var activo = 'todos';

    // Toque en tarjeta (A y B). Se registra en captura para que salga antes de navegar.
    grid.addEventListener('click', function (e) {
      var c = e.target && e.target.closest ? e.target.closest('.ccard') : null;
      if (!c || !grid.contains(c)) return;
      var vis = cards.filter(function (x) { return !x.hidden; });
      track('lm_rec_col_card', { pos: vis.indexOf(c) + 1, handle: c.getAttribute('data-handle') || '', evento: activo, lm_ab_evento: variante() || 'A' });
    }, true);

    var box = document.querySelector('[data-lm-evento]');
    if (!box) return;
    var v = variante();
    if (v !== 'B') {
      // El motor A/B podría cargar después: un solo reintento al terminar de cargar la página.
      if (v === '' && !iniciar.reintento) { iniciar.reintento = 1; window.addEventListener('load', function () { if (variante() === 'B') encender(); }); }
      return;
    }
    encender();

    function encender() {
      if (box.getAttribute('data-lm-on')) return;
      box.setAttribute('data-lm-on', '1');
      box.classList.add('is-on');
      var btns = [].slice.call(box.querySelectorAll('.lmev-b'));
      var st = document.querySelector('[data-lm-evento-st]');
      var cnt = document.querySelector('.lmc .ubar .count');
      var total = cards.length;
      var base = cnt ? cnt.textContent : '';

      function aplicar(btn) {
        var ev = btn.getAttribute('data-ev');
        var todos = ev === 'todos';
        var n = 0;
        cards.forEach(function (c) {
          var ok = todos || (' ' + (c.getAttribute('data-ev') || '') + ' ').indexOf(' ' + ev + ' ') > -1;
          c.hidden = !ok;
          if (ok) n++;
        });
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var nombre = btn.textContent.replace(/\s+/g, ' ').trim();
        var txt = todos ? total + (total === 1 ? ' diseño' : ' diseños') : n + ' de ' + total + (total === 1 ? ' diseño' : ' diseños') + ' · ' + nombre;
        if (cnt) cnt.textContent = todos ? base : txt;
        if (st) st.textContent = txt;
        activo = ev;
        return n;
      }

      function verBoton(b) {
        try {
          var r = b.getBoundingClientRect(), br = box.getBoundingClientRect();
          if (r.left < br.left) box.scrollLeft -= (br.left - r.left) + 12;
          else if (r.right > br.right) box.scrollLeft += (r.right - br.right) + 12;
        } catch (e) {}
      }

      box.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('.lmev-b') : null;
        if (!b || !box.contains(b)) return;
        if (b.getAttribute('aria-pressed') === 'true' && b.getAttribute('data-ev') !== 'todos') b = btns[0];
        var n = aplicar(b);
        verBoton(b);
        track('lm_chip_evento', { evento: b.getAttribute('data-ev'), resultados: n, lm_ab_evento: 'B' });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
